import { EndpointQueryParameters } from '../../../types/strapi/strapi'

export const defaultParams: EndpointQueryParameters = {
    sort: ['id:desc'],
    populate: {
        cost: true,
        order_item: {
            fields: ['documentId', 'id', 'name', 'quantity', 'unit', 'approvedPrice'],
            populate: {
                order: {
                    fields: ['documentId', 'id', 'orderStatus'],
                    populate: {
                        client: {
                            fields: ['documentId', 'name'],
                        },
                    },
                },
            },
        },
    },
}
